var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    fillOpacity: 0.12,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeLinejoin: "round",
    d: "M26.103 23.847c4.877-1.112 5.184-9.05 7.999-9.824-5.841-.963-8.61 1.55-10.128 7.053-1.504-5.414-4.439-8.135-10.008-7.035 3.013.756 2.754 8.321 7.866 9.804-3.942 0-4.233 9.08-8.031 10.132 5.945 1.01 8.774-2.018 10.173-7.336 1.434 5.31 4.631 8.334 10.227 7.386-3.726-.355-3.139-10.182-8.1-10.182"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13.801,
    x2: 34.201,
    y1: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant1);
export default __webpack_public_path__ + "static/media/variant1.64445f5f4ad5602ca6f8f608ae4ccd6b.svg";
export { ForwardRef as ReactComponent };